var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.268,
    height: 46,
    viewBox: "0 0 69.268 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(299.505 -2322.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73",
    transform: "translate(-299.505 2322.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M-204.081,2337.639c-7.325,0-14.652-.082-21.975.033a4.666,4.666,0,0,1-4.178-6.834,3.874,3.874,0,0,1,3.626-2.393c1.84-.027,3.682-.014,5.522-.014q19.5,0,39-.011c1.837,0,3.338.5,4.188,2.236a4.96,4.96,0,0,1-.385,5.334,4.114,4.114,0,0,1-3.712,1.658c-6.635-.018-13.27-.007-19.9-.007Z",
    transform: "translate(246.563 -2327.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M-204.135,2485.556q-10.988,0-21.975,0c-2.29,0-3.666-.917-4.363-2.85a4.536,4.536,0,0,1,1.419-5.385,5.629,5.629,0,0,1,2.97-.927c3.909-.1,7.823-.045,11.735-.045,10.738,0,21.478.089,32.215-.045a4.686,4.686,0,0,1,4.422,6.531,4.012,4.012,0,0,1-4.215,2.716Q-193.032,2485.57-204.135,2485.556Z",
    transform: "translate(246.616 -2440.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M-203.99,2402.351c7.286,0,14.574.1,21.857-.039a4.643,4.643,0,0,1,4.367,6.625,3.963,3.963,0,0,1-3.6,2.6c-.306.02-.613.018-.92.019q-21.858,0-43.716,0c-2.288,0-3.8-.986-4.483-2.878a4.534,4.534,0,0,1,1.448-5.376,5.465,5.465,0,0,1,2.963-.913C-218.716,2402.317-211.353,2402.351-203.99,2402.351Z",
    transform: "translate(246.622 -2383.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M-293.55,2396.688a6.026,6.026,0,0,1,5.9,5.872,6.025,6.025,0,0,1-5.879,6.006,6.072,6.072,0,0,1-5.973-5.929A6.071,6.071,0,0,1-293.55,2396.688Z",
    transform: "translate(299.504 -2379.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M-293.653,2322.546a6.03,6.03,0,0,1,6,5.888,6.006,6.006,0,0,1-5.891,5.984,6.036,6.036,0,0,1-5.962-5.938A6.112,6.112,0,0,1-293.653,2322.546Z",
    transform: "translate(299.505 -2322.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M-287.652,2476.772a6.029,6.029,0,0,1-5.94,5.949,6.11,6.11,0,0,1-5.913-5.989,6.031,6.031,0,0,1,6.016-5.884A6.005,6.005,0,0,1-287.652,2476.772Z",
    transform: "translate(299.505 -2436.722)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/IconMenu.7defa62d.svg";
export { ForwardRef as ReactComponent };